/** Keep in sync with CSS vars in `colors.css` */
export const PRIMARY_BASE = 'var(--primary-base)';
export const PRIMARY_HOVER = 'var(--primary-hover)';
export const PRIMARY_ACTIVE = 'var(--primary-active)';
export const SECONDARY_BASE = 'var(--secondary-base)';
export const SECONDARY_HOVER = 'var(--secondary-hover)';
export const SECONDARY_ACTIVE = 'var(--secondary-active)';
export const FONT_FAMILY = 'var(--font-family)';
export const FONT_FAMILY_HEADING = 'var(--font-family-heading)';
export const FONT_COLOR = 'var(--font-color)';
export const RED_100 = 'var(--red-100)';
export const BLUE_100 = 'var(--blue-100)';
export const BLUE_10 = 'var(--blue-10)';
export const PURPLE_100 = 'var(--purple-100)';
export const PURPLE_10 = 'var(--purple-10)';
export const BLACK_5 = 'var(--black-5)';
export const BLACK_10 = 'var(--black-10)';
export const BLACK_20 = 'var(--black-20)';
export const BLACK_35 = 'var(--black-35)';
export const BLACK_40 = 'var(--black-40)';
export const BLACK_60 = 'var(--black-60)';
export const MINT_100 = 'var(--mint-100)';
export const SHADOW_BASE = 'var(--shadow-base)';
